import React from 'react';
import { motion } from 'framer-motion';
import { OfferModule } from './OfferModule';
import { useCountdown } from '../hooks/useCountdown';
import { Timer, Shield, Lock, Zap } from 'lucide-react';
export function LastCall() {
  const {
    minutes,
    seconds
  } = useCountdown();
  return <section className="py-20 px-4 bg-brown text-cream" data-id="element-122">
      <div className="max-w-4xl mx-auto" data-id="element-123">
        <div className="text-center mb-12" data-id="element-124">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-gold mb-6" data-id="element-125">
            Última llamada
          </h2>
          <p className="font-sans text-lg text-cream/90 max-w-2xl mx-auto leading-relaxed mb-8" data-id="element-126">
            Hoy tenés dos caminos: cerrar esta página y seguir hablándote igual
            que siempre… o empezar a reprogramar tu mente en los próximos 5
            minutos.
          </p>

          <div className="inline-flex items-center gap-2 bg-red-500/10 text-red-400 px-4 py-2 rounded-full font-sans font-bold text-sm border border-red-500/20 mb-12" data-id="element-127">
            <Timer className="w-4 h-4 animate-pulse" data-id="element-128" />
            <span data-id="element-129">
              La oferta vuelve a $49.900 en{' '}
              {minutes.toString().padStart(2, '0')}:
              {seconds.toString().padStart(2, '0')}
            </span>
          </div>
        </div>

        <OfferModule data-id="element-130" />

        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 text-xs md:text-sm font-sans text-cream/50 mt-8" data-id="element-131">
          <span className="flex items-center gap-1.5" data-id="element-132">
            <Lock className="w-4 h-4" data-id="element-133" /> Pago seguro
          </span>
          <span className="hidden md:inline" data-id="element-134">·</span>
          <span className="flex items-center gap-1.5" data-id="element-135">
            <Zap className="w-4 h-4" data-id="element-136" /> Acceso inmediato
          </span>
          <span className="hidden md:inline" data-id="element-137">·</span>
          <span className="flex items-center gap-1.5" data-id="element-138">
            <Shield className="w-4 h-4" data-id="element-139" /> Garantía de 7 días
          </span>
        </div>
      </div>
    </section>;
}